'use client';
import { sortKeys } from '@/constants';
import useSearchParams from '@/hooks/useSearchParams';
import { useTranslations } from 'next-intl';
import React, { useCallback, useMemo, useState, useRef } from 'react';
import useOnClickOutside from '@/hooks/useOnClickOutside';
function SortAndResult({ productsCount, totalProductsCount, isSearchPage }) {
  const t = useTranslations('common');

  const { getFilterObj, setFilterQueryHandler } = useSearchParams();
  const [show, setShow] = useState(false);

  const sortMenuRef = useRef();
  useOnClickOutside([sortMenuRef], () => show && setShow(false));
  const options = useMemo(
    () => [
      ...sortKeys.map((option) => ({
        value: option.code,
        label: t(option.text),
      })),
    ],
    [t]
  );

  const activeSort = useMemo(() => {
    const currentSortValue = new URLSearchParams({
      sortBy: getFilterObj.sortBy || '',
      sortDir: getFilterObj.sortDir || '',
    }).toString();

    return (
      options.find((option) => option.value === currentSortValue) || options[0]
    );
  }, [getFilterObj, options]);

  const handleChange = useCallback(
    (selectedOption) => {
      setFilterQueryHandler(
        Object.fromEntries(new URLSearchParams(selectedOption?.value || ''))
      );
      setShow(false);
    },
    [setFilterQueryHandler]
  );

  return (
    <div
      className={`${!isSearchPage && 'mb-5 flex items-center justify-between max-sm:hidden'}`}
    >
      {!isSearchPage && (
        <p className='text-lg'>
          {t('no_products_key', { productsCount, totalProductsCount })}
        </p>
      )}

      <div className='flex items-center gap-7'>
        <div ref={sortMenuRef} className='relative'>
          <div
            onClick={() => setShow((prev) => !prev)}
            className='flex min-w-35.5 cursor-pointer items-center justify-between gap-1 overflow-hidden rounded-lg border border-[#E4E4F9] bg-white p-2.5'
          >
            <span className='text-xs text-gray-600 uppercase'>
              {activeSort?.label || t('sort_by_key')}
            </span>
            <button className='h-full'>
              <svg
                width={10}
                height={5}
                viewBox='0 0 10 5'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path d='M0 0L5 5L10 0H0Z' fill='black' />
              </svg>
            </button>
          </div>

          {show && (
            <div
              className='absolute end-0 z-[999] mt-2 min-w-36 rounded-md border border-gray-100 bg-white shadow-lg'
              role='menu'
            >
              <div className='p-2'>
                {options?.map((item) => (
                  <button
                    onClick={() => handleChange(item)}
                    key={item?.value}
                    className={`hover:text-primary block w-full cursor-pointer rounded-lg px-4 py-2 text-start text-sm hover:bg-gray-50 ${
                      item?.value === activeSort?.value ? 'text-primary' : ''
                    }`}
                    role='menuitem'
                  >
                    {item?.label}
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SortAndResult;
